import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { ZagButton } from '../button/button';
import { ZagIcon } from '../icon/icon';
import { TooltipDirective } from '../tooltip/index';

export type DropdownSortDimension = 'type' | 'name' | 'priority';

export type DropdownSort = `${DropdownSortDimension}-${'asc' | 'desc'}`;

const DIMENSION_ICONS: Record<DropdownSortDimension, string> = {
  type: 'category',
  name: 'sort_by_alpha',
  priority: 'low_priority',
};

@Component({
  selector: 'zag-dropdown-sort-actions',
  imports: [ZagButton, ZagIcon, TooltipDirective],
  templateUrl: './dropdown-sort-actions.html',
  styleUrl: './dropdown-sort-actions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'group',
    '[attr.aria-label]': 'groupLabel()',
  },
})
export class DropdownSortActions {
  readonly sort = model<DropdownSort>('priority-asc');
  readonly groupLabel = input.required<string>();
  readonly labels = input.required<Partial<Record<DropdownSort, string>>>();
  readonly dimensions = input<readonly DropdownSortDimension[]>(['priority', 'name']);

  protected readonly buttons = computed(() =>
    this.dimensions().map(dimension => {
      const pressed = this.sort().startsWith(dimension);
      const shown: DropdownSort = pressed ? this.sort() : `${dimension}-asc`;
      return {
        dimension,
        icon: DIMENSION_ICONS[dimension],
        pressed,
        label: this.labels()[shown] ?? '',
        directionIcon: shown.endsWith('asc') ? 'arrow_upward' : 'arrow_downward',
      };
    })
  );

  protected toggle(dimension: DropdownSortDimension, event: Event): void {
    event.stopPropagation();
    this.sort.set(this.sort() === `${dimension}-asc` ? `${dimension}-desc` : `${dimension}-asc`);
  }
}
